import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppRoot } from '@telegram-apps/telegram-ui';
import '@telegram-apps/telegram-ui/dist/styles.css';
import telegramAnalytics from '@telegram-apps/analytics';
import { App } from './App';
import './index.css';

// Telegram Mini Apps Analytics — required by @tapps_bot / Telegram Apps Center.
// Token comes from @DataChief_bot (set at build time via VITE_TG_ANALYTICS_TOKEN).
const analyticsToken = import.meta.env.VITE_TG_ANALYTICS_TOKEN as string | undefined;
const analyticsAppName = (import.meta.env.VITE_TG_ANALYTICS_APP_NAME as string | undefined) ?? 'daily-tarot';
if (analyticsToken) {
  try {
    telegramAnalytics.init({ token: analyticsToken, appName: analyticsAppName });
  } catch (err) {
    console.warn('[analytics] init failed:', err);
  }
}

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

createRoot(root).render(
  <StrictMode>
    <AppRoot appearance="dark">
      <App />
    </AppRoot>
  </StrictMode>,
);
